module.exports = __webpack_public_path__ + "static/media/21ECLAC30.77e14452.jpg";